
import React from 'react';
import Carousel from '../components/Carousel';
import ServicesGrid from '../components/ServicesGrid';
import HowItWorks from '../components/HowItWorks';
import usePageTitle from '../hooks/usePageTitle';

function Home() {
  // Título específico para la página de inicio (null usa el default completo)
  usePageTitle(null);

  return (
    <>
      <Carousel />
      <div className="container">
        <ServicesGrid />
        <HowItWorks />
      </div>
    </>
  );
}

export default Home;
